"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
// eslint-disable-next-line energy-cx/nebula-imports
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var analytics_subjects_1 = require("./analytics-subjects");
function NotToCancelLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var doNotCancelDirectDebitLink = 'https://help.ovoenergy.com/article/bf1e92b2-6cca-4833-abeb-cffbbc897aa1-orion'; // TODO: https://ovotech.atlassian.net/browse/CPUT-571
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MOVE_OUT_NOT_CANCEL_DD, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: doNotCancelDirectDebitLink }, children)));
}
function GetQuoteLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var quoteAndSwitch = (0, core_1.useLinks)().quoteAndSwitch;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MOVE_OUT_GET_QUOTE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: quoteAndSwitch(), opensInNewWindow: true }, children)));
}
function ContactUsLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var contactUs = (0, core_1.useLinks)().contactUs;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CONTACT_US_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: contactUs() }, children)));
}
var SwitchingMoveOutLink = function (_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var switchingMoveOut = (0, core_1.useLinks)().switchingMoveOut;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SWITCHING_MOVE_OUT_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { "data-testid": "onboarding-switch-supply-help-link", href: switchingMoveOut(), opensInNewWindow: true }, children)));
};
function ReadingLink(_a) {
    var children = _a.children;
    var _b = (0, core_1.useComponents)(), TextLink = _b.TextLink, InternalLink = _b.InternalLink;
    var meterReads = (0, core_1.useLinks)().meterReads;
    return (react_1.default.createElement(TextLink, { href: meterReads(), as: InternalLink }, children));
}
function PaymentLink(_a) {
    var children = _a.children;
    var _b = (0, core_1.useComponents)(), TextLink = _b.TextLink, InternalLink = _b.InternalLink;
    var payments = (0, core_1.useLinks)().payments;
    return (react_1.default.createElement(TextLink, { href: payments(), as: InternalLink }, children));
}
function QuoteLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var quoteAndSwitch = (0, core_1.useLinks)().quoteAndSwitch;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.GET_QUOTE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: quoteAndSwitch(), opensInNewWindow: true }, children)));
}
function CardPaymentLink(_a) {
    var children = _a.children;
    var _b = (0, core_1.useComponents)(), TextLink = _b.TextLink, InternalLink = _b.InternalLink;
    var cardPayment = (0, core_1.useLinks)().cardPayment;
    return (react_1.default.createElement(TextLink, { href: cardPayment(), as: InternalLink }, children));
}
function ErroneousTransferLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var erroneousTransferHelp = (0, core_1.useLinks)().erroneousTransferHelp;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.ERRONEOUS_TRANSFER, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: erroneousTransferHelp(), opensInNewWindow: true }, children)));
}
function Address(_a) {
    var children = _a.children;
    var _b = (0, core_1.useComponents)(), Pii = _b.Pii, Strong = _b.Strong;
    return (react_1.default.createElement(Strong, { "data-testid": "move-out-address" },
        react_1.default.createElement(Pii, null, children)));
}
var keys = {
    goToHomeLink: 'goToHomeLink',
    backtoHome: 'moveOut.backtoHome',
    moveOutHeading: 'moveOut.moveOutHeading',
    moveOutIntro: 'moveOut.moveOutIntro',
    moveOutNoSelfServeIntro: 'moveOut.moveOutNoSelfServeIntro',
    moveOutNotSupported: 'moveOut.moveOutNotSupported',
    moveOutFeedbackPromptLabel: 'moveOut.feedbackPromptLabel',
    formHeading: 'moveOut.formHeading',
    forwardingAddressQuestion: 'moveOut.forwardingAddressQuestion',
    forwardingAddressInfo: 'moveOut.forwardingAddressInfo',
    forwardingAddressCheckbox: 'moveOut.forwardingAddressCheckbox',
    formDateLabel: 'moveOut.formDateLabel',
    formDateHint: 'moveOut.formDateHint',
    formDatepickerHint: 'moveOut.formDatepickerHint',
    formConfirmButtonText: 'moveOut.formConfirmButtonText',
    formCancelButtonText: 'moveOut.formCancelButtonText',
    confirmationHeading: 'moveOutConfirm.heading',
    confirmationIntroStart: 'moveOutConfirm.introStart',
    confirmationIntroEnd: 'moveOutConfirm.introEnd',
    changeDate: 'moveOutConfirm.changeDate',
    changeDateTitle: 'moveOutConfirm.changeDateTitle',
    changeDateText: 'moveOutConfirm.changeDateText',
    failureModalTitle: 'moveOutConfirm.failureModalTitle',
    failureModalBody: 'moveOutConfirm.failureModalBody',
    changeDateConfirmedTitle: 'moveOutConfirm.changeDateConfirmedTitle',
    changeDateConfirmedBody: 'moveOutConfirm.changeDateConfirmedBody',
    changeDateCloseCTA: 'moveOutConfirm.changeDateCloseCTA',
    cancelTrigger: 'moveOutConfirm.cancelTrigger',
    cancelTitle: 'moveOutConfirm.cancelTitle',
    cancelFailureTitle: 'moveOutConfirm.cancelFailureTitle',
    cancelConfirmTitle: 'moveOutConfirm.cancelConfirmTitle',
    cancelConfirmBody: 'moveOutConfirm.cancelConfirmBody',
    cancelBody: 'moveOutConfirm.cancelBody',
    cancelConfirm: 'moveOutConfirm.cancelConfirm',
    cancelBack: 'moveOutConfirm.cancelBack',
    confirmationAccountNotUpdated: 'moveOutConfirm.accountNotUpdated',
    confirmationSendingFinalReadingsIntro: 'moveOutConfirm.sendingFinalReadingsIntro',
    confirmationSendingFinalReadings: 'moveOutConfirm.sendingFinalReadings',
    finalMeterReadingsSubmitted: 'moveOutConfirm.finalMeterReadingsSubmitted',
    sendMeterReading: 'moveOutConfirm.sendMeterReading',
    sendMeterReadingSecondary: 'moveOutConfirm.sendMeterReadingSecondary',
    confirmationNeedToChangeAnything: 'moveOutConfirm.needToChangeAnything',
    moveOutDateInPastText: 'moveOutConfirm.moveOutDateInPastText',
    confirmationPayingFinalStatement: 'moveOutConfirm.payingFinalStatement',
    confirmationTakeUsWithYou: 'moveOutConfirm.takeUsWithYou',
    confirmationPlansPromo: 'moveOutConfirm.plansPromo',
    confirmationPlansPromoVariation: 'moveOutConfirm.plansPromoVariation',
    confirmationPlansPromoCta: 'moveOutConfirm.plansPromoCta',
    confirmationLoadingPageTitle: 'moveOutConfirm.loadingPageTitle',
    toldUsTitle: 'moveOutConfirm.toldUsTitle',
    movingDayTitle: 'moveOutConfirm.movingDayTitle',
    submitReadingsTitle: 'moveOutConfirm.submitReadingsTitle',
    finalBillTitle: 'moveOutConfirm.finalBillTitle',
    switchTitle: 'moveOutConfirm.switchTitle',
    reminderTitle: 'moveOutConfirm.reminderTitle',
    reminderCTA: 'moveOutConfirm.reminderCTA',
    dateError: 'moveOut.dateError',
    postcodeError: 'moveOut.postcodeError',
    line1Error: 'moveOut.line1Error',
    townError: 'moveOut.townError',
    minDateError: 'moveOut.minDateError',
    minDateInputOnlyError: 'moveOut.minDateInputOnlyError',
    maxDateError: 'moveOut.maxDateError',
    onboardingPageTitle: 'onboarding.pageTitle',
    onboardingHeading: 'onboarding.heading',
    onboardingMessage: 'onboarding.message',
    onboardingOneFuelHeading: 'onboarding.oneFuelHeading',
    onboardingOneFuelMessage: 'onboarding.oneFuelMessage',
    onboardingOneFuelAtOmrMessage: 'onboarding.oneFuelAtOmrMessage',
    onboardingSwitchSupplyHelpLink: 'onboarding.switchSupplyHelpLink',
    onboardingOmrLinkText: 'onboarding.omrLinkText',
    onboardingOmrSubmittedMessage: 'onboarding.omrSubmittedMessage',
    onboardingOmrSubmittedHeading: 'onboarding.omrSubmittedHeading',
    onboardingOmrNewReadsMessage: 'onboarding.omrNewReadsMessage',
    onboardingOmrNewReadsHeading: 'onboarding.omrNewReadsHeading',
    lossDisclosure: 'loss.disclosure',
    lossYouveSwitched: 'loss.youveSwitched',
    lossYouveSwitchedFuel: 'loss.youveSwitchedFuel',
    lossSendReadingHeader: 'loss.sendReadingHeader',
    lossSendReading: 'loss.sendReading',
    lossFinalBalanceInstructions: 'loss.finalBalanceInstructions',
    lossErroneousTransferLink: 'loss.erroneousTransferLink',
    lossSwitchDate: 'loss.switchDate',
    lossClosingBalance: 'loss.closingBalance',
    lossClosingBalanceDebt: 'loss.closingBalanceDebt',
    lossClosingBalanceZero: 'loss.closingBalanceZero',
    lossGetQuote: 'loss.getQuote',
    lossCardPayment: 'loss.cardPayment',
    lossFinalStatements: 'loss.finalStatements',
    lossYoureLeaving: 'loss.youreLeaving',
    lossYoureLeavingFuel: 'loss.youreLeavingFuel',
    lossSorryToSeeYouGo: 'loss.sorryToSeeYouGo',
    lossFuelSwitchDate: 'loss.fuelSwitchDate',
    lossUpcomingFuelSwitchDate: 'loss.upcomingFuelSwitchDate',
    lossFinalFuelStatement: 'loss.finalFuelStatement',
    lossFuelContinueSupply: 'loss.fuelContinueSupply',
    lossStopSupplyDate: 'loss.stopSupplyDate',
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        goToHomeLink: "Go to the homepage",
        moveOut: {
            moveOutHeading: 'Move out',
            backtoHome: 'Back to home',
            moveOutIntro: "<P data-testid='move-out-intro'>Let's begin moving out of <Address>{{address}}</Address>.</P><P>You can tell us about a move that happened in the last 28 days, or that's coming up in the next 28 days. It might take your account a little while to update once you've told us you're moving out.</P>",
            moveOutNoSelfServeIntro: "<P data-testid='move-out-contact-us'>If you're moving out of <Address>{{address}}</Address> in the next 28 days, or if you've already moved out, <ContactUsLink>contact us</ContactUsLink>.</P><P>We'll send you a final statement, refunding any money on your balance, and you won't pay any exit fees.</P>",
            moveOutNotSupported: "<P data-testid='move-out-not-supported'>This feature is not currently supported in your country or region.</P>",
            formHeading: "What's your move out date?",
            forwardingAddressQuestion: "What's your forwarding address?",
            forwardingAddressInfo: '<P>We use this address to send your final statement and any refunds by cheque.</P>',
            forwardingAddressCheckbox: "I don't have a forwarding address, or my address is outside the UK",
            formDateLabel: 'Select date',
            formDateHint: 'For example: 21 09 2019',
            formDatepickerHint: 'For example: 21/09/2019',
            formConfirmButtonText: 'Confirm',
            formCancelButtonText: 'Cancel',
            dateError: 'Enter a valid date',
            postcodeError: 'Enter a valid UK postcode',
            line1Error: 'Enter a valid first line of address',
            townError: 'Enter a valid city/town',
            minDateError: "We can only accept dates in the last 28 days. So your moving out date should be after the {{minDate}}.",
            minDateInputOnlyError: "If you moved out before then <ContactUsLink>contact us</ContactUsLink>",
            maxDateError: "We can only accept dates within the next 28 days. So your moving out date must be before the {{maxDate}}.",
            feedbackPromptLabel: 'How easy was it to tell us about your move out?',
        },
        moveOutConfirm: {
            loadingPageTitle: 'Loading - Confirmation - Move out',
            heading: "<Heading1>You're moving home</Heading1>",
            introStart: "<P>Thanks for telling us you're moving out.  Don't worry if your account's not updated yet, it can take a little while to process a move, so do keep checking back.</P>",
            changeDate: 'Change date',
            changeDateText: '<P>Your current move out date is <Strong>{{date}}</Strong>. If this has changed, enter a new date below.</P>',
            failureModalTitle: "We couldn't change your move out date",
            failureModalBody: "<P>We couldn't process your request. Please try again, or <ContactUsLink>contact us</ContactUsLink>.</P>",
            changeDateTitle: 'Change move out date',
            changeDateConfirmedTitle: "Thanks - we've got your new date",
            changeDateConfirmedBody: "<P>We've got your new move out date of <Strong>{{moveOutDate}}</Strong>. We'll close your contract on this date.</P><P>This may take a few minutes to update on the website.</P>",
            changeDateCloseCTA: 'Close',
            cancelTrigger: 'Or cancel this move',
            cancelTitle: 'Are you sure you want to cancel?',
            cancelBody: "<P>Once you confirm, we'll cancel your move out. If you need to tell us about another move out, you'll be able to fill in the form again once the cancellation has been processed.</P>",
            cancelFailureTitle: "We couldn't cancel your move out",
            cancelConfirm: 'Yes, cancel this move out',
            cancelBack: 'No, take me back',
            cancelConfirmTitle: "Thanks - we've cancelled your move out",
            cancelConfirmBody: "<P>We've cancelled your move out, and won't cancel your contract.</P><P>This may take a few minutes to update on the website.</P>",
            introEnd: "We'll close your contract on this date.",
            accountNotUpdated: "<Dt>Don't worry if your account's not updated yet</Dt>\n    <Dd>\n      It can take a little while to process a move, so do keep checking\n      back.\n    </Dd>",
            sendingFinalReadingsIntro: "If you're on a traditional meter, please <ContactUsLink>contact us</ContactUsLink> on, or after",
            sendingFinalReadings: "<P><Ul><Li>If you have a traditional meter, or your smart meter isn't communicating, please send a reading on the day you move out.</Li><Li>\n      If you have a working smart meter, we'll take a reading automatically.</Li><Li>If you need to submit a meter reading after your move date, please contact us.</Li><Li>If we don't have a reading, we'll estimate your final bill.</Li></Ul></P>",
            sendMeterReading: 'Send meter reading',
            sendMeterReadingSecondary: 'Or send a reading now',
            finalMeterReadingsSubmitted: "<P>We've got your final meter readings, thanks.</P>",
            needToChangeAnything: "<P>Not moving on this day? You can change the date or cancel your move out.</P>",
            moveOutDateInPastText: "<P>Didn't move, or moved on a different day? Please <ContactUsLink>contact us</ContactUsLink> to make any changes.</P>",
            payingFinalStatement: "<P>We'll send your final statement within four weeks of your move out. We kindly ask you <NotToCancelLink>not to cancel your Direct Debit</NotToCancelLink> as we'll use it to pay your balance, then we'll cancel it for you. Cancelling it yourself can lead to accidental double-billing.</P>",
            takeUsWithYou: "<P>Fancy taking us with you? Have a peek at the plans we could offer you at your new home.</P>",
            plansPromo: "<P>Have a peek at the plans we could offer you at your\n    new home. Enter your new address to <GetQuoteLink>get a quote</GetQuoteLink>.</P>",
            plansPromoVariation: "<P>Have a peek at the plans we could offer you at your new home. Enter your new address to get a quote.</P>",
            plansPromoCta: 'Get a quote',
            toldUsTitle: "You told us that you're moving out",
            movingDayTitle: 'Your moving day',
            submitReadingsTitle: 'Submit your final meter readings',
            finalBillTitle: 'Your final bill',
            switchTitle: 'Switch to OVO at your new home',
            reminderCTA: 'Add reminder to calendar',
            reminderTitle: 'Send final meter readings to $t(common.retailer)',
        },
        onboarding: {
            pageTitle: 'Onboarding',
            heading: "Your switch to $t(common.retailer) is underway!",
            message: "<P>Hold tight - we're working on getting you switched and setting up your account.</P><P>Once your switch goes through, you can head back here to do useful things like send us meter readings, see your charges and monthly bills and make changes to your Direct Debit payment.</P>",
            oneFuelHeading: "We're adding your {{gasOrElectricity}} supply!",
            oneFuelMessage: "<P>We're working on adding your energy supply to your $t(common.retailer) account.</P><P data-testid=\"onboarding-home-one-fuel-preOmr\">You don't need to send your meter readings just yet. We'll email you when we're ready for them.</P>",
            oneFuelAtOmrMessage: "<P>We're working on adding your energy supply to your $t(common.retailer) account.</P><P data-testid=\"onboarding-home-one-fuel-atOmr\">Once it goes through, head back here to see your charges, monthly bills and manage your Direct Debit payments.</P>",
            switchSupplyHelpLink: '<P><SwitchingMoveOutLink>Find out more about switching energy supplier</SwitchingMovingOutLink></P>',
            omrLinkText: 'Send meter readings',
            omrSubmittedMessage: "<P>Gave an incorrect reading? No problem, you've 5 days either side of the date we started supplying your energy to send your opening readings.</P>",
            omrSubmittedHeading: 'Thanks for sending your readings',
            omrNewReadsHeading: 'Your opening meter readings',
            omrNewReadsMessage: "<P>Please send your readings by {{omrEndDate}} to make sure your bill's accurate and up to date. If you don't send readings, we'll estimate what you've used.</P>",
        },
        switchTracker: {
            initiatedTitle: "We've started your energy switch",
            omrSubmitTitle: 'Submit your opening meter readings',
            onSupplyTitle: "You're officially on supply",
            beforeOMRWindow: "<P>We'll let you know when it's time to submit your first reading.</P>",
            omrSubmissionRequired: "<P>It's time to submit your first reading, so that your bill is accurate. If you don't submit a reading, we'll estimate what you've used.</P>",
            omrLinkText: 'Send meter readings',
            omrSubmitted: '<P>Thanks for submitting your reading. If you think you got it wrong, you can <ReadingLink>submit a new reading</ReadingLink> up to {{numberOfDays}} days after we start supplying your energy.</P>',
        },
        loss: {
            disclosure: "Full details",
            youveSwitched: "You've switched to a new energy supplier",
            youveSwitchedFuel: "You've switched to a new supplier for {{fuel}}",
            sendReadingHeader: "Need to send a reading?",
            sendReading: "<P>Please send a reading if you haven't sent one recently to make sure your final statement's accurate. <ReadingLink>Send a reading</ReadingLink>.</P>",
            finalBalanceInstructions: "<P>Please don't cancel your Direct Debit - we'll continue to collect it until your account's closed.</P><P>If your final balance is in credit we'll refund this back to your bank account within 10 working days, then close your account.</P><P>If your final balance is in debt, we'll continue collecting your Direct Debit until it's cleared. We'll refund any credit back to your bank account within 10 working days, then close your account.</P><P>You can also make a top-up card payment on your online <PaymentLink>account</PaymentLink> to clear any outstanding debt and speed up the process.</P>",
            erroneousTransferLink: "<P>Didn't ask to switch? <ErroneousTransferLink>Let us know</ErroneousTransferLink>.</P>",
            switchDate: "<P>Your switch happened on <Strong>{{date}}</Strong>.</P>",
            fuelSwitchDate: "<P>Your switch for {{fuel}} happened on <Strong>{{date}}</Strong>.</P>",
            upcomingFuelSwitchDate: "<P>Your switch for {{fuel}} will go ahead on or around <Strong>{{date}}</Strong>.</P>",
            closingBalance: "<P>Your closing balance was {{amount}}, We'll refund this to your bank account within 10 working days.</P><P>We'd love to have you back - check out our plans to see if you could pay less for your energy.</P>",
            closingBalanceDebt: "<P>As your closing account balance was in debt {{amount}}, we'll continue collecting your Direct Debit until this is cleared. If you prefer, you can make a top-up payment into your online account to clear the balance.</P>",
            closingBalanceZero: "<P>Your final balance was <Strong>\u00A30</Strong> so we've now closed your account.</P><P>We'd love to have you back - check out our plans to see if you could pay less for your energy.</P>",
            getQuote: '<P><QuoteLink>Get a quote</QuoteLink></P>',
            cardPayment: '<P><CardPaymentLink>Make an online payment</CardPaymentLink></P>',
            finalStatements: "<P>We'll send separate final statements for your electricity and gas within 6 weeks. These will cover your energy up to the date of your switch.</P>",
            youreLeaving: "We hear you're leaving...",
            youreLeavingFuel: "You're switching your {{fuel}} supplier",
            sorryToSeeYouGo: "<P>We're sorry to see you go but we're doing all we can to make your switch as smooth as possible. There's no need to get in touch.</P>",
            finalFuelStatement: "<P>We'll send your final statement for {{fuel}} within 6 weeks of your switch. This will include your {{fuel}} charges up until the date of your switch.</P>",
            fuelContinueSupply: "<P>We'll keep supplying your {{fuel}} as usual.</P>",
            stopSupplyDate: "<P><Strong>We'll stop supplying your energy on {{date}}.</Strong></P>",
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        ContactUsLink: ContactUsLink,
        NotToCancelLink: NotToCancelLink,
        GetQuoteLink: GetQuoteLink,
        Heading2: nebula_1.Heading2,
        Heading1: nebula_1.Heading1,
        Dt: nebula_1.Dt,
        Dd: nebula_1.Dd,
        SwitchingMoveOutLink: SwitchingMoveOutLink,
        ReadingLink: ReadingLink,
        PaymentLink: PaymentLink,
        ErroneousTransferLink: ErroneousTransferLink,
        QuoteLink: QuoteLink,
        CardPaymentLink: CardPaymentLink,
        Address: Address,
    },
};
exports.defaultOptions = defaultOptions;
